import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PhonePersonalizeSummary from './phone-personalize-summary';
import TabletPersonalizeSummary from './tablet-personalize-summary';

import './index.css';

const personalizePageData = [{
  pageTitle: 'birthday',
  pageIcon: 'BIRTHDAY_CAKE',
  pageName: 'birthday',
}, {
  pageTitle: 'gender',
  pageIcon: 'GENDER_SYMBOLS',
  pageName: 'gender',
}, {
  pageTitle: 'height',
  pageIcon: 'HEIGHT',
  pageName: 'current-height',
}, {
  pageTitle: 'weight',
  pageIcon: 'WEIGHT_SCALE',
  pageName: 'current-weight',
}, {
  pageTitle: 'workout types',
  pageIcon: 'RUNNING',
  pageName: 'workout-type',
}, {
  pageTitle: 'goals',
  pageIcon: 'GOALS',
  pageName: 'multi-fitness-goal',
}, {
  pageTitle: 'workout days',
  pageIcon: 'CALENDAR_WEEK',
  pageName: 'preferred-workout-days',
}, {
  pageTitle: 'activity level',
  pageIcon: 'STEPS',
  pageName: 'daily-activity',
}, {
  pageTitle: 'workout duration',
  pageIcon: 'TIMER',
  pageName: 'preferred-workout-length',
}, {
  pageTitle: 'equipment',
  pageIcon: 'BIKE',
  pageName: 'equipment-preferences',
}];

export class PurePersonalizeSummary extends Component {
  getCompletedStatus() {
    const user = this.props.user;
    return {
      'birthday': true,
      'gender': Boolean(user.gender),
      'height': Boolean(user.height),
      'weight': Boolean(user.weight),
      'workout types': Boolean(user.workout_types && user.workout_types.length),
      'goals': Boolean(user.multiple_fitness_goals && user.multiple_fitness_goals.length),
      'workout days': Boolean(user.workout_days && user.workout_days.length),
      'activity level': Boolean(user.activity_level),
      'workout duration': Boolean(user.preferred_workout_length_min || user.preferred_workout_length_max),
      'equipment': Boolean(user.equipment && user.equipment.length),
    };
  }

  render() {
    return (
      <div className="personalize-summary-page">
        { this.props.mediaType === 'phone'
          ? <PhonePersonalizeSummary personalizePageData={ personalizePageData } completedStatus={ this.getCompletedStatus() } />
          : <TabletPersonalizeSummary personalizePageData={ personalizePageData } completedStatus={ this.getCompletedStatus() } />
        }
      </div>
    );
  }
}

PurePersonalizeSummary.propTypes = {
  mediaType: PropTypes.string,
  user: PropTypes.object,
};

export default connect(
  state => ({
    mediaType: state.config.mediaType,
    user: state.user,
  })
)(PurePersonalizeSummary);
